// extracted by mini-css-extract-plugin
export default {"container":"Common_container__Y4AQ-","main":"Common_main__MG+S2","backIcon":"Common_backIcon__4nhUZ"};